export default function ErrorValidate({ errorText }: any) {
  return <div className="text-danger">{errorText}</div>;
}
